<!-- Case loading -->
@if(lineUpStatus().isLoading){
<app-skeleton-team-lineup />
}

<!-- Case not loading -->
@if (!lineUpStatus().isLoading) {

<div class="font-roboto-400 text-blue-o-50">
  @for (player of teamLineUp(); track player.Id) {
  <div
    nz-row
    class="border-b border-grey-5 py-3 min-h-[70px] flex items-center"
  >
    <!-- Player logo -->
    <div nz-col nzSpan="4">
      @if (player.Photo) {
      <div class="border border-grey-5 p-1 w-fit">
        <img
          alt="player-logo"
          class="w-[60px] max-sm:w-[30px]"
          [src]="player.Photo || urlImg + 'default.png'"
        />
      </div>
      }
    </div>

    <!-- Shirt number -->
    <div nz-col nzSpan="2">
      {{ player.Number }}
    </div>

    <!-- National logo -->
    <div nz-col nzSpan="2">
      @if (player.CountryPhoto) {
      <img
        alt="national_logo"
        class="w-[20px] max-sm:w-[15px]"
        [src]="player.CountryPhoto || urlImg + 'default.png'"
      />
      }
    </div>

    <!-- Player name and short name -->
    <div nz-col nzSpan="12">
      <div class="font-roboto-700 text-blue">
        {{ getPlayerName(player.NameTranslation, player.Name) }}
      </div>
      <!-- @if (player.ShortName) {
      <div>
        ({{ getPlayerName(player.ShortNameTranslation, player.ShortName) }})
      </div>
      } -->
    </div>

    <!-- Position -->
    <div nz-col nzSpan="4" class="truncate">
      @if (player.Position) {
      <span class="text-11 truncate">{{
        "TEAM_EQUIPMENT_LINEUP." + player.Position | translate
      }}</span>
      }
    </div>
  </div>
  }
</div>
}

<!-- Case no data and not loading -->
@if (!lineUpStatus().isLoading && (teamLineUp() === null ||
teamLineUp()?.length! <= 0)) {
<app-no-result message="NotAvalaibleInformation"></app-no-result>
}
